import { RouteInfo } from "./vertical-sidebar.metadata";

export const ROUTES: RouteInfo[] = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        icon: 'fas fa-chart-line',
        extralink: false,
        class: '',
        label: "",
        labelClass: "",
        submenu: [
        ]
    },  
  {
    path: "",
    title: "Archivos",
    icon: "fas fa-archive",
    class: "has-arrow",
    label: "",
    labelClass: "",
    extralink: false,
    submenu: [
        {
            title: 'Tipo de cambio',
            icon: '',
            path: '/modulo/archivos/tipo-cambio-consulta',
            extralink: false,
            class: '',
            label: "",
            labelClass: "",
            submenu: [
            ]
        },
        {
            title: 'Artículo',
            icon: '',
            extralink: false,
            class: 'has-arrow',
            label: "",
            path: "",
            labelClass: "",
            submenu: [
                {
                    title: 'Articulos',
                    icon: 'fas fa-circle',
                    path: `/dashboard/dashboard/${'articulo'}`,
                    class: '',
                    extralink: true, //PARA ABRIR MODAL
                    modal: 'MdArticuloNuevoComponent',
                    label: "",
                    labelClass: "",
                    submenu: [],
                },
                {
                    title: 'Clases',
                    path: '/modulo/archivos/articulos/clases',
                    icon: 'fas fa-circle',
                    extralink: false,
                    class: '',
                    submenu: [],
                    label: "",
                    labelClass: "",
                },
                {
                    title: 'Lista de precios clientes',
                    path: '/modulo/archivos/articulos/lista-precios',
                    icon: 'fas fa-circle',
                    extralink: false,
                    class: '',
                    submenu: [],
                    label: "",
                    labelClass: "",
                },
                {
                    title: 'Lista de precios proveedores',
                    path: '/modulo/archivos/articulos/lista-precios-proveedores',
                    icon: 'fas fa-circle',
                    extralink: false,
                    class: '',
                    submenu: [],
                    label: "",
                    labelClass: "",
                },
            ],

        },
        {
            title: 'Proveedor',
            icon: '',
            extralink: false,
            class: 'has-arrow',
            label: "",
            path: "",
            labelClass: "",
            submenu: [
                {
                    title: 'Proveedores',
                    icon: 'fas fa-circle',
                    path: `/dashboard/dashboard/${'proveedor'}`,
                    class: '',
                    submenu: [],
                    extralink: true,
                    modal: 'MdProveedorNuevoComponent',
                    label: "",
                    labelClass: "",
                },         
            ],

        },
        {
            title: 'Cliente',
            icon: '',
            extralink: false,
            class: 'has-arrow',
            label: "",
            path: "",
            labelClass: "",
            submenu: [
                {
                    title: 'Clientes',
                    path: `/dashboard/dashboard/${'cliente'}`,
                    icon: 'fas fa-circle',
                    class: '',
                    submenu: [],
                    extralink: true,
                    modal: 'MdClienteNuevoComponent',
                    label: "",
                    labelClass: "",
                },        
                {
                    title: 'Clases',
                    path: '/modulo/archivos/interlocutor-comercial/clases',
                    icon: 'fas fa-circle',
                    extralink: false,
                    class: '',
                    submenu: [],
                    label: "",
                    labelClass: "",
                },
            ],

        },
    //   {
    //     path: "/planilla/archivos/personal",
    //     title: "Personal",
    //     icon: "mdi mdi-adjust",
    //     class: "",
    //     label: "",
    //     labelClass: "",
    //     extralink: false,
    //     submenu: [],
    //   },
    //   {
    //     path: "/planilla/archivos/afp/lista",
    //     title: "AFP",
    //     icon: "mdi mdi-adjust",
    //     class: "",
    //     label: "",
    //     labelClass: "",
    //     extralink: false,
    //     submenu: [],
    //   },
    //   {
    //     path: "/planilla/archivos/concepto",
    //     title: "Concepto",
    //     icon: "mdi mdi-adjust",
    //     class: "",
    //     label: "",
    //     labelClass: "",
    //     extralink: false,
    //     submenu: [],
    //   },
    ],
  },
  // {
  //   path: "/planilla/configuracion",
  //   title: "Configuracion",
  //   icon: "fas fa-cogs",
  //   class: "",
  //   label: "",
  //   labelClass: "",
  //   extralink: false,
  //   submenu: [],
  // },
  // {
  //   path: "/dashboard",
  //   title: "Procesos",
  //   icon: "fas fa-briefcase",
  //   label: "",
  //   class: "has-arrow",
  //   labelClass: "",
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: "/planilla/procesos/prestamos",
  //       title: "Prestamos",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/planilla/procesos/generar-planilla",
  //       title: "Procesar planilla",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/planilla/procesos/declaracion-pago-afp",
  //       title: "Declaración y pago AFP",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/planilla/procesos/pago-haberes-cts",
  //       title: "Pago de Haberes y CTS-Bancos",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/planilla/procesos/planilla-electronica-pdt",
  //       title: "Declaración de planilla electrónica-PDT PLAME",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "/dashboard",
  //   title: "Herramientas",
  //   icon: "fas fa-cogs",
  //   label: "",
  //   class: "has-arrow",
  //   labelClass: "",
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: "/planilla/herramientas/formula",
  //       title: "Visualizar formula planilla",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //   ]
  // },
  // {
  //   path: "/dashboard",
  //   title: "Reportes",
  //   icon: "fas fa-archive",
  //   label: "",
  //   class: "has-arrow",
  //   labelClass: "",
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: "/planilla/reportes/planilla-personal",
  //       title: "Planilla de Personal",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/planilla/reportes/resumen-personal",
  //       title: "Resumen por Personal",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/planilla/reportes/resumen-concepto",
  //       title: "Resumen por Concepto",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //   ]
  // }, 

  {
    path: '',
    title: 'Lavandería',
    icon: 'fas fa-bath',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [
        {
            title: 'Guía de Recepción',
            icon: '',
            path: '/modulo/lavanderia/consultas/guia-de-recepcion',
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
        },
        {
            title: 'Guía de Recepción corporativa',
            icon: '',
            path: '/modulo/lavanderia/guia-de-recepcion-corporativa',
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
        },
        {
            title: 'Guía de Remisión',
            icon: '',
            path: '/modulo/lavanderia/consultas/guia-de-remision',
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
        },
        {
            title: 'Comprobantes de venta',
            icon: '',
            path: '',
            label: "",
            class: "has-arrow",
            labelClass: "",
            extralink: false,
            submenu: [

                {
                    title: 'Mostrador',
                    path: '/modulo/lavanderia/comprobante-lista-mostrador',
                    icon: 'fas fa-circle iconos-menus',
                    class: "",
                    label: "",
                    labelClass: "",
                    extralink: false,
                    submenu: [],
                },
                {
                    title: 'Corporativo',
                    path: '/modulo/lavanderia/comprobante-lista',
                    icon: 'fas fa-circle iconos-menus',
                    class: "",
                    label: "",
                    labelClass: "",
                    extralink: false,
                    submenu: [],
                },
                // {
                //     title: 'Extemporáneo',
                //     moduloID: 0, moduloActive: false,
                //     path: '/modulo/lavanderia/comprobante-venta-extemporaneo',
                //     icon: 'fas fa-circle iconos-menus',
                //     extralink: false,
                //     isCollapsed: false,
                //     idcontexto: 2,
                //     class: '',
                //     submenu: []
                // },

            ]
        },
        {
            title: 'Entrega de prendas',
            icon: '',
            path: '/modulo/lavanderia/entrega-prendas',
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
        },
        {
            title: 'Consultas',
            icon: '',
            path: '',
            label: "",
            class: "has-arrow",
            labelClass: "",
            extralink: false,
            submenu: [


                {
                    title: 'Prendas por interlocutor comercial',
                    path: '/modulo/lavanderia/consultas/prendas-por-interlocutor',
                    icon: 'fas fa-circle iconos-menus',
                    class: "",
                    label: "",
                    labelClass: "",
                    extralink: false,
                    submenu: [],
                },

                {
                    title: 'Impresión rapida de guias de recepción',
                    path: '/modulo/lavanderia/consultas/prendas-impresion-rapida',
                    icon: 'fas fa-circle iconos-menus',
                    class: "",
                    label: "",
                    labelClass: "",
                    extralink: false,
                    submenu: [],
                },


            ]
        },
        {
            title: 'Reportes',
      
            icon: '',
            path: '',
            extralink: false,
            label: "",
            class: "has-arrow",
            labelClass: "",
            submenu: [



                {
                    title: 'Reporte de prendas',
                    path: '/modulo/lavanderia/reportes/prendas',
                    icon: 'fas fa-circle iconos-menus',
                    class: "",
                    label: "",
                    labelClass: "",
                    extralink: false,
                    submenu: [],
                },

                {
                    title: 'Registro de guías',
                    path: '/modulo/lavanderia/reportes/registro-guias',
                    icon: 'fas fa-circle iconos-menus',
                    class: "",
                    label: "",
                    labelClass: "",
                    extralink: false,
                    submenu: [],
                },

                {
                    title: 'Registro de ventas',
                    path: '/modulo/lavanderia/reportes/registro-ventas',
                    icon: 'fas fa-circle iconos-menus',
                    class: "",
                    label: "",
                    labelClass: "",
                    extralink: false,
                    submenu: [],
                },
            ]
        },
        {
            title: 'Soporte',
            icon: '',
            path: '',
            extralink: false,
            label: "",
            class: "has-arrow",
            labelClass: "",
            submenu: [

                {
                    title: 'Extemporáneo-Corporativo',
                    path: '/modulo/lavanderia/soporte-corporativo',
                    icon: 'fas fa-circle iconos-menus',
                    extralink: false,
                    label: "",
                    labelClass: "",
                    class: "",
                    submenu: []
                },
                {
                    title: 'Extemporáneo-Mostrador',
                    path: '/modulo/lavanderia/soporte-mostrador',
                    icon: 'fas fa-circle iconos-menus',
                    extralink: false,
                    label: "",
                    labelClass: "",
                    class: "",
                    submenu: []
                },

            ]
        },
    ]
},

];
